import moment from "moment";

export const facturatieMixin = {
  methods: {
    totaal(factuur) {
      var totaal = 0.0;
      if (factuur.Factuurregels) {
        factuur.Factuurregels.forEach(elem => {
          totaal += elem.Aantal * elem.Bedrag;
        });
      }
      return totaal;
    },
    repeatFactuur(orgineel) {
      if (!orgineel) return {};
      var source = orgineel;
      var regels = [];
      var vm = this;
      source.Factuurregels.forEach(function(item) {
        regels.push({
          Aantal: item.Aantal,
          Omschrijving: item.Omschrijving,
          Bedrag: item.Bedrag * vm.index,
          ExtraOmschrijving: item.ExtraOmschrijving,
          Unit: item.Unit // updaten van unit informatie?
        });
      });

      var nieuweDatum = moment(source.Factuurdatum).add("year", 1).toISOString();

      return {
        Datum: nieuweDatum,
        Factuurdatum: nieuweDatum,
        // AutomatischUitsturen: source.AutomatischUitsturen,
        AutomatischUitsturen: false, // AutomatischUitsturen uitgezet voor nieuwe facturen (14-01-2025) 
        VerzendenNaar: source.VerzendenNaar,
        Factuurnummer: null,
        Factuurregels: regels,
        TemplatePath: source.TemplatePath,
        Relatie: source.Relatie,
        Onderwerp: source.Onderwerp,
        Herhalen: source.Herhalen,
        Prijspeiljaar: source.Prijspeiljaar + 1, // de prijs van het nieuwe jaar. (standaard is de herhaling elk 1 jaar)
        Details: source.Details,
        IsHerhalingVan: source,
        orgineelId: source.RemoteId
      };
    }
  }
};
